import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import Translate from "helpers/Translate";
import TextInputbox from "components/Forms/Elements/Textbox";
import Selectbox from "components/Forms/Elements/Selectbox";

const RenameFile = props => {
  const getMetadata = useSelector(state => state.metadata.getMetadata);
  const [metadata, setMetadata] = useState([]);
  const [filenameprefix, setfilenameprefix] = useState(
    getMetadata.data.file_name_prefix || ""
  );

  const [dropdowns, setDropdowns] = useState(
    getMetadata.data.file_rename_dropdowns || {}
  );
  let dropDownsKeys = Object.keys(dropdowns || "");
  const FILE_EXTENSION = ".pdf";

  const getMappedInputs = inputs => {
    const mappedInputs = inputs.length
      ? inputs.map(({ name, value, label }) => ({
          label: label,
          value: value,
          name: name
        }))
      : [];
    return mappedInputs;
  };

  useEffect(() => {
    const inputs = props?.inputs || [];
    const mappedInputs = getMappedInputs(inputs);
    let options = [
      {
        label: "Doc Type Title",
        name: "Doc Type Title",
        value: props.docTypeTitle
      },
      { label: "Manual Entry", name: "Manual Entry", value: "Manual Entry" }
    ];
    options = [...options, ...mappedInputs];

    setMetadata(options);
  }, [getMetadata, props?.inputs]);

  // sen back file renaming data to parent component
  useEffect(() => {
    let fileDetails = {
      fileNamePrefix: filenameprefix,
      fileName: getPreviewFileName(),
      fileRenameDropdowns: dropdowns
    };
    props.onchildcomponentsupdate(fileDetails, "file");
  }, [dropdowns, filenameprefix]);

  const getPreviewFileName = () => {
    let dropDownValues = dropDownsKeys.map((key, index) => {
      return (
        dropdowns[key].inputvalue ||
        dropdowns[key].value ||
        dropdowns[key].label
      );
    });
    dropDownValues = dropDownValues.filter(ele => ele);
    if (!dropDownValues.length) {
      return filenameprefix;
    }

    const path = dropDownValues.toString().replaceAll(",", "_");
    if (filenameprefix) {
      return filenameprefix + "_" + path + FILE_EXTENSION;
    } else {
      return path + FILE_EXTENSION;
    }
  };

  const handleDropdownAdd = () => {
    const dropDownsKeysLength = dropDownsKeys.length;
    setDropdowns({
      ...dropdowns,
      [`dropdown${dropDownsKeysLength + 1}`]: {}
    });
  };

  const handleChange = e => {
    setfilenameprefix(e.target.value);
  };
  const handleDropDowns = (e, dropDownIndex, field) => {
    let defaultlabel = "Doc Type Title";
    let def;
    const inputs = props?.inputs || [];
    const mappedInputs = getMappedInputs(inputs) || [];
    let userInput = mappedInputs.length
      ? mappedInputs.find(ele => ele.value === e.target.value)?.label || ""
      : {};
    const sampleInput = mappedInputs.length
      ? mappedInputs.find(ele => ele.value === e.target.value)?.name || ""
      : {};
    if (e.target.value == props.docTypeTitle) {
      def = true;
      userInput = e.target.value;
    } else if (e.target.value == "Manual Entry") {
      def = false;
      userInput = e.target.value;
    }
    switch (field) {
      case "select": {
        setDropdowns({
          ...dropdowns,
          [`dropdown${dropDownIndex}`]: {
            ...dropdowns[`dropdown${dropDownIndex}`],
            label: def ? defaultlabel : userInput,
            value: e.target.value,
            name: sampleInput,
            order: dropDownIndex
          }
        });
        break;
      }
      case "textBox": {
        setDropdowns({
          ...dropdowns,
          [`dropdown${dropDownIndex}`]: {
            ...dropdowns[`dropdown${dropDownIndex}`],
            label: "Manual Entry",
            inputvalue: e.target.value,
            order: dropDownIndex
          }
        });
        break;
      }
      default: {
        break;
      }
    }
  };

  // handle click event of the Remove button
  const handleFolderRemoveClick = index => {
    let filteredDropdowns = Object.fromEntries(
      Object.entries(dropdowns).filter(([key, value]) => value.order !== index)
    );

    let obj1 = Object.fromEntries(
      Object.entries(filteredDropdowns).filter(
        ([key, value]) => value.order < index
      )
    );
    let obj2 = Object.fromEntries(
      Object.entries(filteredDropdowns).filter(
        ([key, value]) => value.order >= index
      )
    );
    let obj2Keys = Object.keys(obj2);

    obj2Keys.forEach(key => {
      obj2[key].order = obj2[key].order - 1;
    });
    filteredDropdowns = { ...obj1, ...obj2 };
    setDropdowns(filteredDropdowns);
  };

  return (
    <div>
      <h2> {Translate({ id: "design_file_name" })}</h2>
      {""}
      <div className="fx-center-space-between mb-5">
        <label htmlFor="client_label">
          {Translate({ id: "file_name_prefix" })}:
        </label>
        <i
          className="fas fa-info-circle mt-5"
          data-tip={Translate({
            id: "custom_file_name_designed_according_to_metadata"
          })}
        ></i>
      </div>
      <TextInputbox
        id="client_label"
        name="client_label"
        placeholder="c:\scanning\data"
        type="text"
        errorKey={`client_label`}
        fieldValue={filenameprefix}
        onReturnKey={handleChange}
        onChange={handleChange}
      />

      <div>
        <button
          id="add_sub_folder"
          className="btn btn-default-light my-30"
          onClick={() => {
            handleDropdownAdd();
          }}
        >
          <i className="fas fa-plus mr-5"></i>
          {Translate({ id: "add_field" })}
        </button>{" "}
      </div>

      <div>
        {dropDownsKeys.map((key, index) => (
          <div key={index} className="dropdowns">
            <p>Select Field {index + 1} : </p>

            <Selectbox
              options={metadata}
              id={`select-box_${index + 1}`}
              classes="designer"
              errorKey={`select_subfolder_${index + 1}`}
              fieldValue={dropdowns?.[`dropdown${index + 1}`]?.value || ""}
              name={dropdowns?.[`dropdown${index + 1}`]?.name || ""}
              onChange={e =>
                handleDropDowns(
                  e,
                  index + 1,
                  "select",
                  dropdowns?.[`dropdown${index + 1}`]?.label
                )
              }
            />
            {dropdowns?.[`dropdown${index + 1}`]?.label === "Manual Entry" && (
              <TextInputbox
                id={`input_box_file_${index + 1}`}
                classes="designer"
                errorKey={`input_error_file_${index + 1}`}
                fieldValue={dropdowns?.[`dropdown${index + 1}`]?.inputvalue}
                onChange={e => handleDropDowns(e, index + 1, "textBox")}
              />
            )}

            <button
              className="btn-delete btn-primary cancel"
              onClick={() => handleFolderRemoveClick(index + 1)}
            >
              Remove
            </button>
          </div>
        ))}
      </div>
      <br />
      <br />

      {/* <!-- Preview Panel --> */}
      <div className="preview-pane">
        <div className="title">
          <h3>{Translate({ id: "preview" })} </h3>
        </div>
        <div className="help">
          {Translate({ id: "this_is_just_a_readonly_preview_section" })}
        </div>
        <div className="my-30">Preview Of Built Out File Name : </div>
        <h4>{getPreviewFileName()}</h4>
      </div>
    </div>
  );
};

export default RenameFile;
